import { render, staticRenderFns } from "./BaseGroup.vue?vue&type=template&id=e849078a"
import script from "./BaseGroup.vue?vue&type=script&lang=ts"
export * from "./BaseGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports